<template>
  <div class="home">
    <h1 class="red-text text-lighten-2">Track what you love</h1>
    <i class="material-icons red-text text-lighten-2">library_books</i>
    <i class="material-icons red-text text-lighten-2">gamepad</i>
    <i class="material-icons red-text text-lighten-2">tv</i>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {

    }
  }
}
</script>
<style>
  body {
    background: url('~@/assets/geometry2.png');
    width: 100%;
    height: 100%;
  }

  .home {
    text-align: center;
  }

  .home h1 {
    margin-top: 150px;
    font-family: 'Dancing Script', cursive;
    font-size: 40px;
    animation-name: fade-in;
    animation-duration: 5s;
  }

  .home i {
    padding: 20px;
    font-size: 24px;
    animation-name: fade-in;
    animation-duration: 5s;
  }

  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @media screen and (min-width: 400px) {
    .home h1 {
      margin-top: 250px;
      font-size: 50px;
    }

    .home i {
      padding: 20px;
      font-size: 36px;
    }
  }

  @media screen and (min-width: 600px) {
    .home h1 {
      margin-top: 270px;
      font-size: 70px;
    }

    .home i {
      padding: 20px;
      font-size: 36px;
    }
  }

  @media screen and (min-width: 800px) {
    .home h1 {
      margin-top: 270px;
      font-size: 100px;
    }

    .home i {
      padding: 20px;
      font-size: 36px;
    }
  }
</style>
